var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('form',{on:{"submit":function($event){$event.preventDefault();}}},[_c('LocalBaserowServiceForm',{attrs:{"application":_vm.application,"default-values":_vm.defaultValues},on:{"values-changed":function($event){return _vm.emitServiceChange($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }